export { default } from "./ContentHero";
